/**
 * @generated SignedSource<<ae912838ff7285012d55c1439c08f3d6>>
 * @lightSyntaxTransform
 * @nogrep
 */
/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
import { ConcreteRequest } from 'relay-runtime';

export type ConfirmationPageMutation$variables = {
  code: string;
  creditApplicationId: string;
  e164: string;
};
export type ConfirmationPageMutation$data = {
  readonly fraudAlertChallengeSubmit: {
    readonly success: boolean;
  };
};
export type ConfirmationPageMutation = {
  response: ConfirmationPageMutation$data;
  variables: ConfirmationPageMutation$variables;
};

const node: ConcreteRequest = (function () {
  var v0 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'code',
    },
    v1 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'creditApplicationId',
    },
    v2 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'e164',
    },
    v3 = [
      {
        alias: null,
        args: [
          {
            fields: [
              {
                kind: 'Variable',
                name: 'code',
                variableName: 'code',
              },
              {
                kind: 'Variable',
                name: 'creditApplicationId',
                variableName: 'creditApplicationId',
              },
              {
                kind: 'Variable',
                name: 'e164',
                variableName: 'e164',
              },
            ],
            kind: 'ObjectValue',
            name: 'q',
          },
        ],
        concreteType: 'FraudAlertChallengeSubmitResponse',
        kind: 'LinkedField',
        name: 'fraudAlertChallengeSubmit',
        plural: false,
        selections: [
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'success',
            storageKey: null,
          },
        ],
        storageKey: null,
      },
    ];
  return {
    fragment: {
      argumentDefinitions: [v0 /*: any*/, v1 /*: any*/, v2 /*: any*/],
      kind: 'Fragment',
      metadata: null,
      name: 'ConfirmationPageMutation',
      selections: v3 /*: any*/,
      type: 'Mutation',
      abstractKey: null,
    },
    kind: 'Request',
    operation: {
      argumentDefinitions: [v1 /*: any*/, v2 /*: any*/, v0 /*: any*/],
      kind: 'Operation',
      name: 'ConfirmationPageMutation',
      selections: v3 /*: any*/,
    },
    params: {
      cacheID: 'dbc0f1c2538278b70393b938c64a6064',
      id: null,
      metadata: {},
      name: 'ConfirmationPageMutation',
      operationKind: 'mutation',
      text: 'mutation ConfirmationPageMutation(\n  $creditApplicationId: String!\n  $e164: String!\n  $code: String!\n) {\n  fraudAlertChallengeSubmit(q: {creditApplicationId: $creditApplicationId, e164: $e164, code: $code}) {\n    success\n  }\n}\n',
    },
  };
})();

(node as any).hash = 'b84abb74b2bf6e468cf99bdc7f437a00';

export default node;
